<mat-progress-bar
    appShowWhenLoading
    mode="indeterminate"
    [color]="(sidenavMode$ | async) === 'over' ? 'accent' : 'primary'"
></mat-progress-bar>

<router-outlet></router-outlet>
